import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="bg-blue-950 text-slate-300" data-id="element-92" data-mp="3gfsmscqd8umz">
      <div className="metal-silver h-1.5 w-full" aria-hidden="true" data-id="element-93" data-mp="3ggk8mvu5ve02" />
      <div className="mx-auto max-w-3xl px-4 py-10 text-center" data-id="element-94" data-mp="32ovuyo49khgz">
        <p className="text-lg font-extrabold uppercase text-white" data-id="element-95" data-mp="36p6cmy1f4wbo">{productShortName}</p>
        <p className="mt-3 text-sm" data-id="element-96" data-mp="3uf0obca04euc">Created by nuclear energy education specialists, for educators worldwide.</p>
        <p className="mt-6 border-t border-slate-300/20 pt-6 text-xs" data-id="element-97" data-mp="38h3r5ed5aiu">
          © 2026 {productShortName} — All rights reserved.
        </p>
      </div>
    </footer>;
}